import React from "react";
import "./servicecs.css";


const ServiceCS = ({caseStudies}) => {
  return (
    <section className="service-cs" id="case-study">
      <div className="service-cs__container container">

        {/* Heading */}
        <div className="service-cs__title">
          <span></span>
          <h2>{caseStudies.sectionTitle}</h2>
        </div>

        {/* Case Studies Grid */}
        <div className="service-cs__grid">
          {caseStudies.items.map((study) => (
            <article
              className="case-study-card"
              key={study.id}
            >

              {/* Image */}
              <div className="case-study-card__image">
                <img
                  src={study.image}
                  alt={study.title}
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="case-study-card__content">

                <h3 className="case-study-card__title">
                  {study.title}
                </h3>

                <p className="case-study-card__description">
                  {study.description}
                </p>

                {/* Gradient Line */}
                <div className="case-study-card__line"></div>

                {/* Button */}
                <a
                  href={study.link}
                  className="case-study-card__button"
                >
                  Read more
                </a>

              </div>

            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServiceCS;